import { makeStyles, Tab, TabList } from "@fluentui/react-components";
import { useState } from "react";
import FlightOps_Overview_Builds from "./FlightOps_Overview_Builds";
import FlightOps_Overview_OrphanedBuilds from "./FlightOps_Overview_OrphanedBuilds";
import FlightOps_Overview_AudienceAdoption from "./FlightOps_Overview_AudienceAdoption";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    }
});

export default function FlightOps_Overview() {
    const styles = useStyles();
    const [ selectedTab, setSelectedTab ] = useState( "builds" );

    return (
        <div className={styles.root}>
            <TabList selectedValue={selectedTab} onTabSelect={( _, d ) => setSelectedTab(d.value as string)}>
                <Tab value="builds">Current Builds</Tab>
                <Tab value="orphaned">Orphaned Builds</Tab>
                <Tab value="adoption">Audience Adoption</Tab>
            </TabList>

            {
                selectedTab == "builds" ? <FlightOps_Overview_Builds /> :
                selectedTab == "orphaned" ? <FlightOps_Overview_OrphanedBuilds /> :
                selectedTab == "adoption" ? <FlightOps_Overview_AudienceAdoption /> : null
            }
        </div>
    );
}